import { checkEnableParseJSON, formatBooleanToYesNo, formatDate, tryParseJSON } from 'components/helper/helper';
import React from 'react';
import SimpleTable from 'components/table/SimpleTable';
//import ItemContent from './ItemContent';

interface Props {
  data: any;
}

const SATTestSum = ({ data }: Props) => {
  console.log('SATTestSum data:', data);
  let csu_info = tryParseJSON(data?.csu_info);

  return (
    <div className="gm-summary-section2">
      <div className="gm-summary-section-title">SAT Tests</div>
        <div className="p-8">
          <div className="gm-summary-field-grid">
            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">College Board ID</div>
              <div className="gm-summary-text-dark">{csu_info?.collegeBoardId || 'N/A'}</div>
            </div>

            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Number of past SAT scores you wish to report*</div>
              <div className="gm-summary-text-dark">{data?.number_of_past_sat_scores || 'N/A'}</div>
            </div>
            
            <div className="gm-summary-field-item">
              <div className="gm-summary-text-primary">Have you taken the SAT essay?*</div>
              <div className="gm-summary-text-dark">{formatBooleanToYesNo(data?.taken_sat_essay_option)}</div>
            </div>
          </div>

          <div className="gm-summary-table-section">
            <div className="gm-summary-field-label" style={{ marginBottom: '16px' }}>
              SAT Test Scores
            </div>
            <SimpleTable
              column={[
                { label: 'Test Date', value: 'test_date', formatDate: true },
                { label: 'Total Score', value: 'total_score' },
                { label: 'R/W', value: 'reading_writing_score' },
                { label: 'Math', value: 'math_score' },
                {...(data?.taken_sat_essay_option === "true" || data?.taken_sat_essay_option === true)? { label: 'Combined Essay Scores', value: 'essay_scores' }: {}},
                {...(data?.taken_sat_essay_option === "true" || data?.taken_sat_essay_option === true) ? { label: 'Essay Reading', value: 'essay_reading' }: {}},
                {...(data?.taken_sat_essay_option === "true" || data?.taken_sat_essay_option === true) ? { label: 'Essay Analysis', value: 'essay_analysis' }: {}},
                {...(data?.taken_sat_essay_option === "true" || data?.taken_sat_essay_option === true) ? { label: 'Essay Writing', value: 'essay_writing' } : {}},
              ]}
              data={csu_info?.sat_score}
              equalColumns={true}
            />
          </div>

          <div className="gm-summary-subsection">
            <div className="gm-summary-subsection-title">Super Score</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-text-primary">Highest R/W score</div>
                <div className="gm-summary-text-dark">
                  {data?.highest_evidence_reading_writing_score || 'N/A'}
                  {data?.evidence_reading_writing_date && (
                    <div className="gm-summary-field-label">
                      {formatDate(data?.evidence_reading_writing_date)}
                    </div>
                  )}
                </div>
              </div>
              
              <div className="gm-summary-field-item">
                <div className="gm-summary-text-primary">Highest Math Score</div>
                <div className="gm-summary-text-dark">
                  {data?.highest_math_score_based_evidence_reading_writing_score || 'N/A'}
                  {data?.math_reading_writing_date && (
                    <div className="gm-summary-field-label">
                      {formatDate(data?.math_reading_writing_date)}
                    </div>
                  )}
                </div>
              </div>
              
              {(data?.taken_sat_essay_option === "true" || data?.taken_sat_essay_option === true) && (
                <div className="gm-summary-field-item">
                  <div className="gm-summary-text-primary">Highest Combined Essay Score</div>
                  <div className="gm-summary-text-dark">
                    {data?.combined_essay_score || 'N/A'}
                    {data?.combined_essay_date && (
                      <div className="gm-summary-field-label">
                        {formatDate(data?.combined_essay_date)}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className="gm-summary-subsection">
            <div className="gm-summary-subsection-title">Future SATs</div>
            <div className="gm-summary-field-grid">
              <div className="gm-summary-field-item">
                <div className="gm-summary-text-primary">Number of future SAT sittings you expect*</div>
                <div className="gm-summary-text-dark">{data?.future_sat_tests_plan_to_take || '0'}</div>
              </div>
              
              <div className="gm-summary-field-item">
                <div className="gm-summary-text-primary">Future testing date 1</div>
                <div className="gm-summary-text-dark">
                  {formatDate(checkEnableParseJSON(data.future_testing_date_1)?.test1) || 'N/A'}
                </div>
              </div>
              
              <div className="gm-summary-field-item">
                <div className="gm-summary-text-primary">Future testing date 2</div>
                <div className="gm-summary-text-dark">
                  {formatDate(checkEnableParseJSON(data.future_testing_date_1)?.test2) || 'N/A'}
                </div>
              </div>
              
              <div className="gm-summary-field-item">
                <div className="gm-summary-text-primary">Future testing date 3</div>
                <div className="gm-summary-text-dark">
                  {formatDate(checkEnableParseJSON(data.future_testing_date_1)?.test3) || 'N/A'}
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default SATTestSum;
